import React,{Component} from 'react';
// import {connect} from 'react-redux';
import {reduxForm} from 'redux-form';
import * as actions from '../../../actions';
import {browserHistory,Link} from 'react-router';
import { Modal, Button,} from 'react-bootstrap';
import Footer from './footer.js';
// import $ from 'jquery';

const baseAssets = 'https://aquadeals.in/admin/assets/';
class EnquireNow extends Component{
	constructor(props){
		super(props);
			this.state={
					ltype : this.props.params.Ltype,
					sid: this.props.params.Sid,
					did: this.props.params.Did,
					showModal: false,
			};
	this.modalOpen=this.modalOpen.bind(this);
    this.close=this.close.bind(this);
    this.closeModal=this.closeModal.bind(this);
	};
  modalOpen(){
  this.setState({
    showModal: true
  });
}
closeModal(){
  this.setState({
    showModal: false,
  });
}
close(){
  this.setState({
    showModal: false,
  });
}

componentWillReceiveProps(newProps) {
    if (newProps.leads === 1 || newProps.leads.status === 'success') {
      this.setState({showModal: true});
    } else {
      this.setState({showModal: false});
    }
}
componentWillUnmount(newProps){
}

handleFormSubmit(formProps){
	// console.log(this.state.ltype);
	if(this.state.ltype === "seed"){
		this.props.saveseed_lead(formProps,this.state.sid,this.state.did);
	}
	if(this.state.ltype === "feed"){
		this.props.savefeed_lead(formProps,this.state.sid,this.state.did);	
	}
	if(this.state.ltype === "seller"){
	this.props.savefeed_lead(formProps,this.state.sid,this.state.did);	
		//this.props.track_seller_lead(formProps,this.state.sid,this.state.did);	
	}
	if(this.state.ltype === "nodata"){
		this.props.track_user_lead(formProps,this.state.sid,this.state.did);	
	}	
  }
componentDidMount(){
  if(screen.width >=800){
    window.location.href="/web/enquire/type/sid/did";
  }
}
render(){
	// console.log(this.props.leads);
  var redirect = '';
  if(this.state.ltype === 'seller'){
  	redirect = '/customer_care_seller';
  }
  else
  {
  	redirect = '/customer_care';
  }
  const {handleSubmit,fields:{name,number,email}} = this.props;
  return (
<section className="mob_deals tot_pag mob_enquire_page">
	<div className="page_hdr">
			<div className="container-fluid">
				<h5><Link onClick={()=>{browserHistory.goBack()}}><i><img src={baseAssets+'images/web_imgs/back_arrow.png'} width="18px" alt=""/></i></Link>Enquire Now</h5>
        <a href="/home" className="home_newicon"><img src={baseAssets+'mob-assets/home1.png'} alt="Home" /></a>
				
			</div>
	</div>
	<section className="pag_cntnt">
	<div className="container">
		<div className="login_logo"><img src={baseAssets+'images/web_imgs/logo.png'} title="" alt="Aquadeals" /></div>
		<div className="login_form">
			<form className="mtrl_elmnts" onSubmit={handleSubmit(this.handleFormSubmit.bind(this))}>
				<div className="group">      
					<img src={baseAssets+'icons/web_icons/user.png'} alt="" style={{position:'absolute',top:'6px',left:'0px'}} />
					<input {...name} type="text" placeholder="Name" />
					<span className="highlight"></span>
					<span className="bar"></span>
					<span>{name.touched && name.error && <div className="text-danger">{name.error}</div>}</span>
				</div>
				<div className="group">      
					<img src={baseAssets+'icons/web_icons/cell_dl.png'} alt="" style={{position:'absolute',top:'6px',left:'0px'}} />
					<input {...number} type="text" maxLength={10} placeholder="Mobile" />	
					<span className="highlight"></span>
					<span className="bar"></span>
					<span>{number.touched && number.error && <div className="text-danger">{number.error}</div>}</span>
				</div>
				<div className="group">      
					<img src={baseAssets+'icons/web_icons/email_dl.png'} alt="" style={{position:'absolute',top:'6px',left:'0px'}} />
					<input {...email} type="text" placeholder="Email(Optional)"  />
					<span className="highlight"></span>
					<span className="bar"></span>
					<span><div className="text-danger">{email.error ? email.error : ''}</div></span>
				</div>
				<div className="row">
					<div className="col-md-6 col-xs-6 col-sm-6"></div>
					<div className="col-md-6 col-xs-6 col-sm-6"><button action="submit" className="btn mob_enq_btn">Enquire</button></div>
				</div>
			</form>
		</div>
	</div>
	</section>

<Modal backdrop="static" className="showModal modal fade" show={this.state.showModal} style={{zIndex: '1111'}} onHide={this.close}>
        <Modal.Header style={{borderBottom: 'none' }}>
                <Modal.Title style={{fontSize: 16+'px',color:'#333'}}></Modal.Title>
              </Modal.Header>
              <Modal.Body>
              	<div style={{textAlign: 'center'}}><img width={70} src={baseAssets+'images/web_imgs/conformed.png'} alt="..." /></div> 
                <h4 style={{textAlign: 'center', fontSize:14+'px', color:'#666'}}>Your details has been submitted successfully</h4>
              </Modal.Body>
              <Modal.Footer className="modal_footer" style={{borderTop: 'none',textAlign: 'center'}}>
                  {/* <Button style={{background: '#fff none repeat scroll 0 0',color:'#ff742a'}} onClick={ this.closeModal}>Close</Button>*/}
                  <Link to={redirect}><Button style={{background: '#ff742a none repeat scroll 0 0',color: '#fff'}}>OK</Button></Link>
              </Modal.Footer>
      </Modal>
	{/*<Footer />*/}
</section>
    );
  }
}


function validate(formProps){
const errors = {};
const namePattern = /^[a-zA-Z0-9\x20]{3,25}/;

if(!formProps.name){
  errors.name = "Enter your name";
}else if(formProps.name && !namePattern.test(formProps.name)){
		errors.name = 'Enter minimum 3 characters';
}




const invalidChars = /[^0-9]/gi;
 if(formProps.number && invalidChars.test(formProps.number)){
 	errors.number="invalid mobile number";
 }

const number_check = /^[0-9]{10}$/;  
 if(formProps.number && !number_check.test(formProps.number)){
 	errors.number="Mobile number must contains 10 numbers only";
 }

 if(!formProps.number){
 	errors.number="Enter Mobile Number";
 }

const emailPattern = /(.+)@(.+){2,}\.(.+){2,}/;
  if (formProps.email && !emailPattern.test(formProps.email))
   {
    errors.email = 'Enter a valid email';
	}
if(!formProps.email)
{
	formProps.email='';
}




// const emailPattern = /(.+)@(.+){2,}\.(.+){2,}/;
//   if (!emailPattern.test(formProps.email)) {
//     errors.email = 'Enter a valid email';
//   }
  
return errors;
}


function mapStateToProps(state){
    return {
        leads:state.posts.leads,
    }
}

export default reduxForm({
  form :'Enquiry',
  fields:['name','number','email'],
  validate:validate

},mapStateToProps,actions)(EnquireNow);


/** WEBPACK FOOTER **
 ** ./src/components/Categories/Common/Enquire_now.js
 **/